import { useCan } from '../useCan';
import { CustomerDetail } from './CustomerDetail';
import { StaffCustomerCard } from './StaffCustomerCard';

/** /be/klanten/:id — wie alle klanten mag zien krijgt het volledige dossier, een collega de beperkte klantkaart. */
export function CustomerByRole() {
  const {
    canAll
  } = useCan();
  return canAll('customers.view') ? <CustomerDetail data-id="element-1154" data-mp="2je38lw7bgm8y" /> : <StaffCustomerCard data-id="element-1155" data-mp="2jgpfruqaozqn" />;
}